// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1b71u","options":"AnswerScale_options__1xGtY","selected":"AnswerScale_selected__3cGuu"};